import React from 'react';

import { PromoDangerouslyHtml } from 'apps/promo/components/common/promo-dangerously-html/PromoDangerouslyHtml';

import styles from './QuoteTileSmall.module.css';

export interface QuoteTileSmallProps {
    img?: string;
    text?: string;
    description?: string;
    loadingLazy?: boolean;
}

export const QuoteTileSmall: React.FC<QuoteTileSmallProps> = ({ ...props }) => {
    return (
        <div className={styles.container}>
            <div className={styles.topRow}>
                {props.img && (
                    <div className={styles.imgContainer}>
                        <img src={props.img} alt={props.description} />
                    </div>
                )}
                {props.description && <PromoDangerouslyHtml tag="div" variant={'subheader'} dangerouslyHtml={props.description} color={'gray40'} />}
            </div>
            {props.text && <PromoDangerouslyHtml tag="div" variant={'h4'} dangerouslyHtml={props.text} color={'white'} />}
        </div>
    );
};
